import { motion } from "framer-motion";
import { Layers, Map, Plane } from "lucide-react";

const features = [
  {
    icon: Plane,
    title: "Aviation Specialists",
    description:
      "20+ years of expertise working in high-security airport zones (Airside & Landside).",
  },
  {
    icon: Layers,
    title: "Design to Delivery",
    description:
      "Seamless coordination from architectural planning to civil execution and premium interior finishing.",
  },
  {
    icon: Map,
    title: "Pan-India Reach",
    description:
      "Active operational hubs in Delhi, Mumbai, Lucknow, and Jaipur, delivering consistency across locations.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section className="relative py-24 px-6 md:px-12 lg:px-24 bg-neutral-900 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop"
          alt="Abstract Architecture"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-linear-to-t from-neutral-900 via-transparent to-neutral-900" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-serif text-4xl md:text-5xl font-light text-white mb-6">
            Our Distinct Edge
          </motion.h2>
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "6rem" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-primary mx-auto"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              whileHover={{ y: -10 }}
              className="group relative p-8 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-white/20 hover:bg-white/10 transition-all duration-300 shadow-xl">
              {/* Glow Effect on Hover */}
              <div className="absolute inset-0 -z-10 rounded-xl bg-linear-to-b from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="flex flex-col items-center text-center">
                <div className="mb-6 p-4 rounded-full bg-white/5 group-hover:bg-primary/10 transition-colors duration-300">
                  <feature.icon
                    className="w-12 h-12 text-primary transition-transform duration-300 group-hover:scale-110"
                    strokeWidth={1.5}
                  />
                </div>

                <h3 className="font-serif text-2xl text-white mb-4">
                  {feature.title}
                </h3>

                <p className="text-gray-400 font-light leading-relaxed group-hover:text-gray-300 transition-colors">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <motion.a
            href="/about"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-block px-8 py-3 bg-primary text-white font-serif text-lg tracking-wide rounded-sm hover:bg-[#c40102] transition-colors duration-300">
            Learn More About Our Journey
          </motion.a>
        </div>
      </div>
    </section>
  );
};
